import { useContext, useEffect, useState } from "react";

import { AuthContext } from "../context/AuthProvider";
import { fetchWithInterceptor } from "../utils/fetchWithInterceptor";

export default function useLocations() {
  const { token } = useContext(AuthContext);

  const [countries, setCountries] = useState([]);
  const [regions, setRegions] = useState([]);
  const [subregions, setSubregions] = useState([]);

  useEffect(() => {
    if (!token) return;

    const headers = {
      "Content-Type": "application/json",
      "x-access-token": token,
    };
    const loadLocations = async () => {
      try {
        const [countriesRes, regionsRes, subregionsRes] = await Promise.all([
          fetchWithInterceptor(
            "/api/locations?type=country&isActive=true&limit=500&includeParent=false",
            { headers },
          ),
          fetchWithInterceptor(
            "/api/locations?type=region&isActive=true&limit=500&includeParent=false",
            { headers },
          ),
          fetchWithInterceptor(
            "/api/locations?type=subregion&isActive=true&limit=500&includeParent=false",
            { headers },
          ),
        ]);

        if (countriesRes?.ok) {
          const data = await countriesRes.json();
          setCountries(data.rows || []);
        }

        if (regionsRes?.ok) {
          const data = await regionsRes.json();
          setRegions(data.rows || []);
        }

        if (subregionsRes?.ok) {
          const data = await subregionsRes.json();
          setSubregions(data.rows || []);
        }
      } catch (err) {
        console.error(err);
      }
    };

    loadLocations();
  }, [token]);

  return { countries, regions, subregions };
}
